import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';
import get from 'lodash/get';
import Ad from '../ad/ad';
import FCLink from '../fc_link/fc_link';
import asyncPostNativeAdActions from '../../../redux/actions/post/async_post_native_ad_actions';
import adLoaded from '../../../redux/action_creators/ads_action_creator';
import ClientSideWrapper from '../client_side_wrapper/client_side_wrapper';
import { canUseDOM } from 'exenv';

// TODO: move to utils
const handleMegatronImage = (img, customFields) => {
  const MEGATRON_KEY = 'megatron_image';

  const REPLACE_600 =
    'upload/w_600,ar_16:9,c_fill,g_auto:body,g_north,f_auto,q_auto:best/';
  const REPLACE_2048 =
    'upload/w_2480,ar_16:9,c_fill,g_auto:body,g_north,f_auto,q_auto:best/';

  const GIF_EXTENSION = '.gif';
  const UPLOAD_DIR = 'upload/';

  const megatronCustomField = get(customFields, MEGATRON_KEY);
  const imgSrc = megatronCustomField || img.source;

  return imgSrc.includes(GIF_EXTENSION)
    ? imgSrc.replace(UPLOAD_DIR, REPLACE_600)
    : imgSrc.replace(UPLOAD_DIR, REPLACE_2048);
};

const tempSponsoredArticles = [
  {
    image:
      'https://images.fastcompany.net/image/upload/w_1153,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/wp-cms/uploads/2020/05/GettyImages-1179510604.jpg',
    eyebrow: 'PRESENTED BY USERTESTING',
    title: 'Why brands are failing to listen to customers—and how to fix that',
    url:
      'https://www.fastcompany.com/90508691/why-brands-are-failing-to-listen-to-customers-and-how-to-fix-that'
  },
  {
    image:
      'https://images.fastcompany.net/image/upload/w_1153,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/wp-cms/uploads/2020/02/SkiiersForMcK.jpg',
    eyebrow: 'PRESENTED BY MCKINSEY & COMPANY',
    title: 'How to leverage your company’s competitive edge',
    url:
      'https://www.fastcompany.com/90469211/how-to-leverage-your-companys-competitive-edge'
  },
  {
    image:
      'https://images.fastcompany.net/image/upload/w_1153,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/wp-cms/uploads/2020/05/5G-Lab-04-reszied-1.jpg',
    eyebrow: 'Presented by Verizon',
    title: 'The future is being created here',
    link:
      'https://www.fastcompany.com/90507645/the-future-is-being-created-here'
  }
];

class Megatron extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      activeNative: true,
      // sponsoredCardData: null,
      tempSponsoredCardData: null
    };

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.swiperResize = this.swiperResize.bind(this);
  }

  componentWillMount() {
    const randomSponorCard = Math.floor(Math.random() * 3);
    // random 0 - 2
    if (get(this, 'props.config.featureFlags.isDynamicNativeTileEnabled')) {
      this.setState({
        tempSponsoredCardData: get(
          this,
          `props.megatronNativeTile.posts[${randomSponorCard}]`
        )
      });
    } else {
      this.setState({
        tempSponsoredCardData: tempSponsoredArticles[randomSponorCard]
      });
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.swiperResize);
  }

  componentWillReceiveProps(nextProps) {
    const nativeAdHomepageTileLoaded = get(
      nextProps,
      'adsLoaded.native_homepagefeature'
    );

    if (nativeAdHomepageTileLoaded) {
      this.setNativeAd();
      this.props.dispatchAdLoadedEvent('native_homepagefeature', false);
    }

    const newPostNativeAd = get(
      nextProps,
      'postNativeAd.homepageFeaturedTile.posts'
    );

    if (
      get(newPostNativeAd, 'length') !==
        get(this.props, 'postNativeAd.homepageFeaturedTile.posts.length') &&
      get(newPostNativeAd, 'length')
    ) {
      this.setState({
        // sponsoredCardData: newPostNativeAd
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.swiperResize);
  }

  onMouseEnter(index) {
    this.setState({ activeIndex: index });
    this.swiper.slideTo(index);
    this.swiper.autoplay.stop();
  }

  onMouseLeave() {
    this.swiper.autoplay.start();
  }

  setNativeAd() {
    const nativeAdsData = get(window, 'fc_ads.native.homepageFeaturedTile');

    if (!nativeAdsData) {
      return;
    }

    // Check if it's native_type === homepageFeaturedTile
    if (get(nativeAdsData, 'native_type') === 'homepageFeaturedTile') {
      if (
        !get(nativeAdsData, 'article_ids') &&
        !get(nativeAdsData, 'campaign_name') &&
        !get(nativeAdsData, 'clickthrough_url')
      ) {
        return;
      }

      this.props.dispatchPostNativeAd(nativeAdsData, get(this.props, 'config'));
    }
  }

  swiperResize() {
    this.swiper.update();
  }

  render() {
    const { activeIndex, activeNative, tempSponsoredCardData } = this.state;
    const { articles, config, combinedAdModel } = this.props;
    const settings = {
      effect: 'fade',
      autoplay: {
        delay: 4000
      },
      on: {
        slideChangeTransitionStart: () => {
          const { activeIndex: ai } = this.swiper;
          if (ai === 2 && activeNative) {
            this.setState({
              activeNative: false
            });
          }
          this.setState({ activeIndex: ai });
        }
      }
    };

    return (
      <Fragment>
        <div className="megatron">
          <Swiper
            {...settings}
            ref={node => {
              if (node) this.swiper = node.swiper;
            }}
          >
            {articles.map(({ featured_image: img, customFields }) => (
              <div key={img.source} className="megatron__slide">
                <div
                  className="megatron__slide-background"
                  style={{
                    backgroundImage: `url(${handleMegatronImage(
                      img,
                      customFields
                    )})`
                  }}
                />
              </div>
            ))}
          </Swiper>
          <div className="megatron__articles">
            {articles.map(
              ({ title, categories, customFields, link }, index) => (
                <article
                  key={link}
                  className={`megatron__article ${
                    activeIndex === index ? 'megatron__article--active' : ''
                  }`}
                  onMouseEnter={() => this.onMouseEnter(index)}
                  onMouseLeave={this.onMouseLeave}
                >
                  <FCLink title={title} to={link} config={config}>
                    {get(customFields, 'primary_eyebrow', false) ? (
                      <span>{get(customFields, 'primary_eyebrow', '')}</span>
                    ) : (
                      <span>{get(categories[0], 'name', '')}</span>
                    )}
                    <h2>{title}</h2>
                  </FCLink>
                </article>
              )
            )}
            {tempSponsoredCardData &&
              canUseDOM && (
                <div
                  className={`megatron__article megatron__article--native ${
                    activeNative ? 'megatron__article--native__active' : ''
                  }`}
                >
                  <a href={tempSponsoredCardData.url}>
                    <div className="img-container">
                      <img
                        src={tempSponsoredCardData.image}
                        alt={tempSponsoredCardData.title}
                      />
                    </div>
                    <span>{tempSponsoredCardData.eyebrow}</span>
                    <h2>{tempSponsoredCardData.title}</h2>
                  </a>
                </div>
              )}
          </div>
        </div>

        <div className="homepage-page__ff-ad-container">
          <ClientSideWrapper showOnlyDesktop={true}>
            <Ad {...combinedAdModel} name="flexiblebillboard_1" />
          </ClientSideWrapper>
        </div>
      </Fragment>
    );
  }
}

Megatron.propTypes = {
  config: PropTypes.shape({}).isRequired,
  articles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  dispatchAdLoadedEvent: PropTypes.func.isRequired,
  dispatchPostNativeAd: PropTypes.func.isRequired,
  megatronNativeTile: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

function mapStateToProps(state = {}) {
  return {
    config: state.config,
    postpage: state.postpage,
    postNativeAd: get(state, 'postNativeAd.data', {}),
    adsLoaded: get(state, 'ads.data')
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchPostNativeAd(nativeAdsData, config) {
      return asyncPostNativeAdActions(dispatch, config, nativeAdsData);
    },

    dispatchAdLoadedEvent(adName, status) {
      dispatch(adLoaded(adName, status));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Megatron);
